import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import MastakashLogoIcon from '../../assets/logoIcon.png'

export default function TopNavbar({returnTo=false}) {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);


  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="home" smooth={true}>
        <img src={MastakashLogoIcon} width='35%' height='35%'/>
           
          </Link>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
             {
              returnTo ?
              <a href="/">Home</a>
            :
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
            Home
          </Link>
             }
            </li>


             <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a style={{ padding: "10px 15px" }} href="/#how-it-works" spy={true} smooth={true} offset={-80}>
                Services
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="how-it-works" spy={true} smooth={true} offset={-80}>
              How It Works
            </Link>
              }
              
            </li>

            

           
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a style={{ padding: "10px 15px" }} href="/#services" spy={true} smooth={true} offset={-80}>
                Services
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="services" spy={true} smooth={true} offset={-80}>
              Services
            </Link>
              }
              
            </li>

             <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a style={{ padding: "10px 15px" }} href="/#financial-inclusion" spy={true} smooth={true} offset={-80}>
                Financial Inclusion
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="financial-inclusion" spy={true} smooth={true} offset={-80}>
              Financial Inclusion
            </Link>
              }
              
            </li>

            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#features" spy={true} smooth={true} offset={-80}>
                Features
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="features" spy={true} smooth={true} offset={-80}>
              Features
            </Link>

              }
            
            </li>
            
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#faqs" spy={true} smooth={true} offset={-80}>
                FAQs
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="faqs" spy={true} smooth={true} offset={-80}>
              FAQs
            </Link>

              }
             
            </li>


          

           {/*  <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#invest" spy={true} smooth={true} offset={-80}>
                Invest
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="invest" spy={true} smooth={true} offset={-80}>
              Invest
            </Link>

              }
             
            </li>*/}

             <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#fundraising" spy={true} smooth={true} offset={-80}>
                Fundraising
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="fundraising" spy={true} smooth={true} offset={-80}>
              Fundraising
            </Link>

              }
             
            </li>

            
                     
          
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#about" spy={true} smooth={true} offset={-80}>
                About
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="about" spy={true} smooth={true} offset={-80}>
              About
            </Link>

              }
           
            </li>
            <li className="semiBold font15 pointer">
              {
                returnTo ?
                <a activeClass="active" style={{ padding: "10px 15px" }} href="/#contact" spy={true} smooth={true} offset={-80}>
                Contact
              </a>
              :
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="contact" spy={true} smooth={true} offset={-80}>
              Contact
            </Link>

              }
             
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
           {/* <li className="semiBold font15 pointer">
              <a href="https://roshchms.roshtech.co.ke" target="_blank" style={{ padding: "10px 30px 10px 0" }}>
                Log in
              </a>
            </li>
            <li className="semiBold font15 pointer flexCenter">
              <a href="https://roshchms.roshtech.co.ke/signup" target="_blank" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                Get Started
              </a>
            </li>*/}
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


